/**
 * Logikk for Workplace Stress Index (WSI)
 * Basert på 5 kjernefaktorer for arbeidsrelatert stress.
 */

export const stressFactors = [
  { id: 'workload', name: 'Arbeidsmengde', icon: 'Layers', desc: 'Den totale mengden oppgaver i forhold til tid.' },
  { id: 'timePressure', name: 'Tidspress', icon: 'Clock', desc: 'Opplevelse av knappe frister og hastverk.' },
  { id: 'balance', name: 'Work-Life Balance', icon: 'Sun', desc: 'Evne til å koble av og skille jobb fra fritid.' },
  { id: 'recovery', name: 'Restitusjon', icon: 'Battery', desc: 'Mulighet for pauser og henting av energi i løpet av dagen.' },
  { id: 'leaderSupport', name: 'Lederstøtte', icon: 'User', desc: 'Oppleves lederen som en støttespiller ved høyt press?' }
];

export const getStressStatus = (score) => {
  if (score >= 81) return { label: 'Kritisk stress', color: 'rose', status: 'Critical', bg: 'bg-rose-50' };
  if (score >= 61) return { label: 'Høyt stress', color: 'orange', status: 'High', bg: 'bg-orange-50' };
  if (score >= 31) return { label: 'Moderat stress', color: 'amber', status: 'Moderate', bg: 'bg-amber-50' };
  return { label: 'Lavt stress', color: 'emerald', status: 'Low', bg: 'bg-emerald-50' };
};

export const teamStressData = [
  { team: 'Utvikling', score: 82, trend: 'up' },
  { team: 'Salg', score: 65, trend: 'up' },
  { team: 'Support', score: 45, trend: 'down' },
  { team: 'Marked', score: 28, trend: 'stable' },
  { team: 'HR', score: 22, trend: 'down' }
];

export const getStressRecommendations = (score) => {
  const actions = [];
  
  if (score >= 81) {
    actions.push({
      title: "Arbeidsbelastnings-analyse",
      desc: "Umiddelbar gjennomgang av oppgaver og ressurser for å identifisere 'flaskehalser'.",
      icon: 'Search'
    });
  }
  
  if (score >= 61) {
    actions.push({
      title: "Lederstøtte-trening",
      desc: "Veiledning for ledere i hvordan de kan skjerme ansatte og prioritere i krisetider.",
      icon: 'Award'
    });
  }
  
  if (score >= 31) {
    actions.push({
      title: "Stressmestring-workshop",
      desc: "Praktiske verktøy for teamet for å håndtere krysspress og restitusjon.",
      icon: 'Zap'
    });
  }
  
  return actions;
};